import React, { Component } from 'react'
import { extend } from '../../../../../utils/classes'

export class Link extends Component {
  render() {
    const { parentClass, Icon } = this.props
    const baseClass = extend(parentClass, 'item')
    return (
      <li className={baseClass}>
        <Icon className={extend(baseClass, 'icon')} />
      </li>
    )
  }
}

export default Link
